import { render } from "./UploadPostMedia.vue?vue&type=template&id=b6c876f0&scoped=true"
import script from "./UploadPostMedia.vue?vue&type=script&lang=js"
export * from "./UploadPostMedia.vue?vue&type=script&lang=js"

import "./UploadPostMedia.vue?vue&type=style&index=0&id=b6c876f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c876f0"]])

export default __exports__